module.exports = __webpack_public_path__ + "img/CPTsample2-1.3a928d09.png";